
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { toast } from "sonner";
import { ArrowLeft, Beer, Mail, Lock, User, Phone, MapPin, ShieldCheck } from "lucide-react";

const RegisterPage = () => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    address: ""
  });

  const { register } = useAuth();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validatePassword = (password) => {
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);

    return password.length >= 8 && hasUppercase && hasNumber;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error("As senhas não coincidem");
      return;
    }

    if (!validatePassword(formData.password)) {
      toast.error("A senha precisa ter 8 caracteres, número e letra maiúscula.");
      return;
    }

    setLoading(true);

    try {
      await register(
        formData.name,
        formData.email,
        formData.password,
        formData.phone,
        formData.address
      );

      toast.success("Cadastro enviado. Aguarde aprovação do administrador.");

      setFormData({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        phone: "",
        address: ""
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.detail ||
        error?.message ||
        "Erro ao criar conta"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center text-[#F59E0B] hover:text-[#F97316] mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Voltar para o site
        </Link>

        <Card className="bg-black/50 border-[#F59E0B]/30">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="bg-[#F59E0B] p-3 rounded-full">
                <Beer className="w-8 h-8 text-black" />
              </div>
            </div>

            <CardTitle className="text-2xl text-white">
              Criar sua conta
            </CardTitle>

            <CardDescription className="text-gray-400">
              Todos os cadastros passam por aprovação manual.
            </CardDescription>

            <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-3 mt-4 text-left">
              <div className="flex items-start gap-2">
                <ShieldCheck className="w-5 h-5 text-yellow-400 mt-0.5" />

                <div className="text-sm text-yellow-100">
                  Contas suspeitas ou automatizadas serão bloqueadas automaticamente.
                </div>
              </div>
            </div>
          </CardHeader>

          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label className="text-white">Nome</Label>
                <div className="relative mt-2">
                  <User className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                  <Input name="name" value={formData.name} onChange={handleChange} className="pl-10" required />
                </div>
              </div>

              <div>
                <Label className="text-white">E-mail</Label>
                <div className="relative mt-2">
                  <Mail className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                  <Input type="email" name="email" value={formData.email} onChange={handleChange} className="pl-10" required />
                </div>
              </div>

              <div>
                <Label className="text-white">Telefone</Label>
                <div className="relative mt-2">
                  <Phone className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                  <Input name="phone" value={formData.phone} onChange={handleChange} className="pl-10" required />
                </div>
              </div>

              <div>
                <Label className="text-white">Endereço</Label>
                <div className="relative mt-2">
                  <MapPin className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                  <Input name="address" value={formData.address} onChange={handleChange} className="pl-10" required />
                </div>
              </div>

              <div>
                <Label className="text-white">Senha</Label>
                <div className="relative mt-2">
                  <Lock className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                  <Input type="password" name="password" value={formData.password} onChange={handleChange} className="pl-10" required />
                </div>
              </div>

              <div>
                <Label className="text-white">Confirmar senha</Label>
                <div className="relative mt-2">
                  <Lock className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                  <Input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className="pl-10" required />
                </div>
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-[#F59E0B] hover:bg-[#D97706] text-black font-bold"
              >
                {loading ? "Enviando..." : "Solicitar cadastro"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default RegisterPage;
